import { render, staticRenderFns } from "./ConfirmRemoveDownload.vue?vue&type=template&id=94a1af22&scoped=true"
import script from "./ConfirmRemoveDownload.vue?vue&type=script&lang=js"
export * from "./ConfirmRemoveDownload.vue?vue&type=script&lang=js"
import style0 from "./ConfirmRemoveDownload.vue?vue&type=style&index=0&id=94a1af22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a1af22",
  null
  
)

export default component.exports